// SEO meta 工具：详情页拿到真实数据后写入 <title>/description/keywords/og 标签。
// 说明：meta[name] 与 meta[property] 混用（og 用 property），需分别按属性定位。

function ensureMeta(attr, key) {
	let el = document.head.querySelector(`meta[${attr}="${key}"]`);
	if (!el) {
		el = document.createElement("meta");
		el.setAttribute(attr, key);
		document.head.appendChild(el);
	}
	return el;
}

// 去掉富文本 HTML 标签与多余空白，用于 <meta description>
export function stripHtml(s) {
	return String(s || "")
		.replace(/<[^>]*>/g, "")
		.replace(/&nbsp;/g, " ")
		.replace(/&amp;/g, "&")
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/\s+/g, " ")
		.trim();
}

export function setSeoMeta(opts) {
	try {
		const { title, description, keywords, image } = opts || {};
		if (title) document.title = title;
		const desc = stripHtml(description).slice(0, 150);
		if (desc) ensureMeta("name", "description").setAttribute("content", desc);
		if (keywords) ensureMeta("name", "keywords").setAttribute("content", String(keywords).slice(0, 150));
		// og 同步（微信/社交分享卡片）
		ensureMeta("property", "og:title").setAttribute("content", document.title);
		if (desc) ensureMeta("property", "og:description").setAttribute("content", desc);
		if (image) ensureMeta("property", "og:image").setAttribute("content", image);
	} catch (e) {
		console.error("[seo]", e && e.message);
	}
}
